export const defaultValues = {
  sec1: {
    preg1: {
      titulo: 'Para iniciar indícanos. ¿Cuál es el nombre de tu empresa? 🏭',
      text: '',
      value: '',
    },
    preg2: {
      titulo: '¿A qué Industria pertenece tu empresa?',
      text: '',
      value: '',
    },
    preg3: {
      titulo: '¿De qué país y ciudad es tu empresa?',
      text: '',
      value: '',
    },
    preg4: {
      titulo: '¿Actualmente qué cargo desempeñas en tu empresa?',
      text: '',
      value: '',
    },
    preg5: {
      titulo: 'URL de la página web de tu empresa.',
      text: '',
      value: '',
    },
    preg6: {
      titulo: 'Danos una breve descripción de tu empresa',
      text: '',
      value: '',
    },
    preg7: {
      titulo: '¿Cuál es tu correo electrónico?',
      text: '',
      value: '',
    },
  },
  sec2: {
    preg8: {
      text: [],
      value: 'multiple',
    },
    preg9: {
      text: [],
      value: 'multiple',
    },
    preg10: {
      text: [],
      value: 'multiple',
    },
  },
  sec3: {
    preg11: {
      titulo:
        '¿Cómo describirías la integración de tu estrategia digital con tu estrategia empresarial general?',
      text: '',
      value: 0.33,
    },
    preg12: {
      titulo:
        '¿En qué medida los objetivos digitales están definidos y son conocidos por toda tu empresa?',
      text: '',
      value: 0.33,
    },
    preg13: {
      titulo:
        '¿Cómo se priorizan las inversiones en tecnología digital en tu empresa?',
      text: '',
      value: 0.66,
    },
    preg14: {
      titulo:
        '¿Cuál es el nivel de entendimiento digital entre los líderes de tu empresa?',
      text: '',
      value: 0.66,
    },
    preg15: {
      titulo:
        '¿Cómo se comunica y se implementa la estrategia digital en tu empresa?',
      text: '',
      value: 0.33,
    },
  },
  sec4: {
    preg16: {
      titulo:
        '¿Cómo utilizas en tu empresa los canales digitales para interactuar con los clientes? (Página web, redes sociales, blogs, aplicaciones, software, crm de comunicación…)',
      text: '',
      value: 0.33,
    },
    preg17: {
      titulo:
        '¿En qué medida tu empresa recopila y utiliza datos de clientes para mejorar la experiencia?',
      text: '',
      value: 0.66,
    },
    preg18: {
      titulo:
        '¿Cómo calificarías la coherencia de la experiencia del cliente a través de diferentes canales digitales?',
      text: '',
      value: 0.15,
    },
    preg19: {
      titulo:
        '¿Cuál es la integración del marketing digital con otras estrategias de la empresa, como ventas y servicio al cliente?',
      text: '',
      value: 0.66,
    },
    preg21: {
      titulo:
        '¿Cómo se manejan los feedbacks y quejas de clientes en canales digitales?',
      text: '',
      value: 0.33,
    },
    preg20: {
      titulo:
        '¿Cuál es el nivel de satisfacción del cliente con las interacciones digitales?',
      text: '',
      value: 0.66,
    },
  },
  sec5: {
    preg27: {
      titulo:
        '¿Cómo se prepara tu empresa para el futuro digital, considerando tendencias emergentes y disruptivas?',
      text: '',
      value: 0.66,
    },
    preg26: {
      titulo:
        '¿Cómo describirías la capacidad de tu empresa para adaptarse a cambios tecnológicos y de mercado?',
      text: '',
      value: 1,
    },
    preg25: {
      titulo: '¿Cómo se fomenta y reconoce la innovación dentro en tu empresa?',
      text: '',
      value: 0.66,
    },
    preg23: {
      titulo:
        '¿En qué medida los empleados están empoderados para probar nuevas ideas y tecnologías?',
      text: '',
      value: 1,
    },
    preg24: {
      titulo:
        '¿Cuál es el nivel de apoyo y compromiso del liderazgo con la innovación digital?',
      text: '',
      value: 0.33,
    },
    preg22: {
      titulo: '¿Cómo describirías la cultura de innovación en tu empresa?',
      text: '',
      value: 0.66,
    },
  },
  sec6: {
    preg31: {
      titulo:
        '¿Cómo manejas los aspectos legales de la transformación digital en tu empresa?',
      text: '',
      value: 0.15,
    },
    preg30: {
      titulo:
        ' ¿Cómo gestionas en tu empresa los derechos de propiedad intelectual en el entorno digital?',
      text: '',
      value: 0.33,
    },
    preg29: {
      titulo:
        '¿En qué medida se implementan prácticas de protección de datos y privacidad en tu empresa?',
      text: '',
      value: 1,
    },
    preg28: {
      titulo:
        '¿Cómo describirías el cumplimiento legal y normativo de tu empresa en el entorno digital?',
      text: '',
      value: 0.66,
    },
  },
  sec7: {
    preg32: {
      titulo: '¿Cómo calificaría la infraestructura tecnológica de tu empresa?',
      text: '',
      value: 0.33,
    },
    preg33: {
      titulo: 'No utilizamos la automatización de procesos',
      text: '',
      value: 0.33,
    },
    preg34: {
      titulo: '¿Cómo gestionas los datos y la analítica en tu empresa?',
      text: '',
      value: 0.33,
    },
    preg35: {
      titulo:
        '¿Cómo gestionas los fallos tecnológicos y los incidentes de seguridad?',
      text: '',
      value: 0.66,
    },
    preg36: {
      titulo:
        '¿Cómo calificaría la integración de nuevas tecnologías en tu empresa?',
      text: '',
      value: 0.66,
    },
    preg37: {
      titulo:
        ' ¿Cómo aseguras que tu empresa mantenga la seguridad tecnológica?',
      text: '',
      value: 0.66,
    },
  },
  sec8: {
    preg43: {
      titulo:
        '¿Cómo comunicás y entrenas a los empleados sobre riesgos digitales y seguridad?',
      text: '',
      value: 0.66,
    },
    preg42: {
      titulo:
        '¿Cómo evalúas el impacto de las nuevas tecnologías en los riesgos empresariales?',
      text: '',
      value: 0.66,
    },
    preg40: {
      titulo:
        '¿Cuál es el nivel de preparación de tu empresa ante ciberataques?',
      text: '',
      value: 1,
    },
    preg41: {
      titulo:
        '¿Cómo gestionas la continuidad del negocio ante interrupciones digitales?',
      text: '',
      value: 0.66,
    },
    preg38: {
      titulo:
        '¿Cómo identificar y gestionar en tu empresa los riesgos digitales?',
      text: '',
      value: 0.66,
    },
    preg39: {
      titulo: '¿Cómo gestionas el riesgo en la innovación?',
      text: '',
      value: 0.33,
    },
  },
};
